import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    field: undefined,
    recommendation: undefined,
    plantingDate: undefined,
    humidity: undefined,
    environment: undefined,
    density: undefined,
    hybrid: undefined,
    fertilizer: undefined,
    fertilizerAmount: undefined,
    btnDisabled: false,
    cropProtectionProducts: [],
    comesFromNotification: false,
};

export default createReducer(initial, {
    [actions.setField]: (state, action) => {
        return {
            ...state,
            field: action.payload,
        };
    },
    [actions.setRecommendation]: (state, action) => {
        return { ...state, recommendation: action.payload };
    },
    [actions.setPlantingDate]: (state, action) => {
        return { ...state, plantingDate: action.payload };
    },
    [actions.setHumidity]: (state, action) => {
        return { ...state, humidity: action.payload };
    },
    [actions.setEnvironment]: (state, action) => {
        return { ...state, environment: action.payload };
    },
    [actions.setDensity]: (state, action) => {
        return { ...state, density: action.payload };
    },
    [actions.setHybrid]: (state, action) => {
        return { ...state, hybrid: action.payload };
    },
    [actions.setFertilizer]: (state, action) => {
        return { ...state, fertilizer: action.payload };
    },
    [actions.setFertilizerAmount]: (state, action) => {
        return { ...state, fertilizerAmount: action.payload };
    },
    [actions.setBtnDisabled]: (state, action) => {
        return { ...state, btnDisabled: action.payload };
    },
    [actions.resetCropMonitoring]: (state, action) => {
        return initial;
    },
    [actions.setCropProtectionProducts]: (state, action) => {
        return { ...state, cropProtectionProducts: action.payload };
    },
    [actions.setComesFromNotification]: (state, action) => {
        return { ...state, comesFromNotification: action.payload };
    },
});
